module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl p-l-20 border-box",
    style: ('width:' + _vm.width + ';height:' + _vm.height)
  }, [_c('div', {
    staticClass: "bor-deep-gra bg-wh h-100p ovf-auto"
  }, [_c('p', {
    staticClass: " ft-bold p-t-20 p-b-20 m-t-0 m-b-0 m-l-30 m-r-30 bor-b-gray"
  }, [_vm._v("配置项")]), _vm._v(" "), _c('div', {
    staticClass: "p-t-20 p-l-30 p-r-30"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curNode,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "路由备注",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curRoute.remark),
      expression: "curRoute.remark"
    }],
    staticClass: "h-40 w-230",
    domProps: {
      "value": (_vm.curRoute.remark)
    },
    on: {
      "input": function($event) {
        _vm.curRoute.remark = $event
      }
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16a4ef68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/abstract/routeConfig.vue
// module id = 1783
// module chunks = 2